import PropertyItem from './PropertyItem';
import { PropertyItemProps, PropertyItemValueProps } from './types';

export type { PropertyItemProps, PropertyItemValueProps };
export default PropertyItem;
